import { Company } from '../types';

export const parseCSV = (content: string): Company[] => {
  const lines = content.split(/\r?\n/).filter(line => line.trim() !== '');
  if (lines.length < 2) return [];

  // Robust line parser handling quotes (e.g. "Company, Inc.")
  const parseLine = (text: string): string[] => {
    const result: string[] = [];
    let cell = '';
    let inQuotes = false;
    
    for (let i = 0; i < text.length; i++) {
      const char = text[i];
      
      if (char === '"') {
        // Handle escaped quotes ("") if needed, or just toggle state
        if (inQuotes && text[i+1] === '"') {
           cell += '"';
           i++; // skip next quote
        } else {
           inQuotes = !inQuotes;
        }
      } else if (char === ',' && !inQuotes) {
        result.push(cell.trim());
        cell = '';
      } else {
        cell += char;
      }
    }
    result.push(cell.trim());
    return result;
  };

  // Parse headers and normalize
  const headers = parseLine(lines[0]).map(h => h.toLowerCase().replace(/['"]+/g, ''));
  
  // Helper to find index by fuzzy key
  const findIdx = (keys: string[]) => headers.findIndex(h => keys.some(k => h.includes(k)));

  const nameIdx = findIdx(['name', 'company', 'firm']);
  const descIdx = findIdx(['desc', 'about', 'info', 'description']);
  const indIdx = findIdx(['industry', 'sector', 'cat']);
  const webIdx = findIdx(['web', 'url', 'site']);
  const locIdx = findIdx(['loc', 'city', 'country', 'address']);

  return lines.slice(1).map((line, index) => {
    const cols = parseLine(line);
    
    // Fallbacks: if headers aren't found, try positional: 0=Name, 1=Desc, etc.
    return {
      id: `csv-${Date.now()}-${index}`,
      name: (nameIdx > -1 ? cols[nameIdx] : cols[0]) || 'Unknown Company',
      description: (descIdx > -1 ? cols[descIdx] : cols[1]) || 'No description',
      industry: (indIdx > -1 ? cols[indIdx] : cols[2]) || 'General',
      website: (webIdx > -1 ? cols[webIdx] : '') || '',
      location: (locIdx > -1 ? cols[locIdx] : '') || ''
    };
  });
};
